import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromProducts from '../reducers/products.reducer';
import * as fromRoot from '../../../store';
import { ToEntities } from 'src/app/utility';
import { Product } from '../../models';

// tslint:disable-next-line:max-line-length
export const getProductState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.products);

export const getProductEntities = createSelector(getProductState, fromProducts.getProductsEntities);
export const getProductsDetailEntities = createSelector(getProductState, fromProducts.getProductsDetailEntities);

export const getAllProducts = createSelector(getProductEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]);
});
export const getProductsLoaded = createSelector(getProductState, fromProducts.getProductsLoaded);
export const getProductsLoading = createSelector(getProductState, fromProducts.getProductsLoading);
export const getProductsCollectionHandle = createSelector(getProductState, fromProducts.getProductsCollectionHandle);
export const getProductsPageInfo = createSelector(getProductState, fromProducts.getProductsPageInfo);
export const getProductsFilteredPageInfo = createSelector(getProductState, fromProducts.getProductsFilteredPageInfo);

export const getSelectedproduct = createSelector(getProductEntities, fromRoot.getRouterState, (entities, router) => {
  return router.state && entities[router.state.params['productHandle']];
});

export const getProductsQueried = createSelector(getProductState, fromProducts.getProductsQueried);
export const getProductsByQuery = createSelector(getProductsQueried, sections => {
  return <{ [key: string]: Product[] }>Object.keys(sections).reduce((prev, section, i) => {
    return {
      ...prev,
      [section]: Object.keys(sections[section]).map(id => sections[section]?.[id as unknown as number]),
    };
  }, {});
});
export const getProductsByGlobalSearch = createSelector(getProductsQueried, loadedSections => {
  const searchResults = loadedSections['global-search'];
  return !searchResults ? [] : Object.keys(searchResults).map(id => searchResults[id as unknown as number]);
});

export const getProductsByOrderAgain = createSelector(getProductsQueried, loadedSections => {
  const searchResults = loadedSections['order-again'];
  return !searchResults ? [] : Object.keys(searchResults).map(id => searchResults[id as unknown as number]);
});

export const getFilteredProductEntities = createSelector(getProductState, fromProducts.getProductsFiltered);

export const getProductsCollectionFiltered = createSelector(getFilteredProductEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]);
});

export const getSelectedProductColors = createSelector(getSelectedproduct, getProductsByQuery, (product, queried) => {
  return product && queried[`color-variants_${product.id}`];
});

export const getRecommendationsFor = createSelector(getProductState, fromProducts.getRecommendationsFor);
export const getRecommendationsLoading = createSelector(getProductState, fromProducts.getRecommendationsLoading);
export const getRecommendations = createSelector(getProductState, fromProducts.getRecommendations);

export const getProductSectionStates = createSelector(getProductState, fromProducts.getProductSectionStates);
export const getProductError = createSelector(getProductState, fromProducts.getProductError);
export const getProductSearchQuery = createSelector(getProductState, fromProducts.getProductSearchQuery);
